import { Button } from 'react-bootstrap';
import { Trans } from 'react-i18next';
import NewsLetterModal from './NewsLetterModal';
import React, { useState } from "react";

function NewsLetterButton({ brochure }) {
    let [showBrochure, setShowBrochure] = useState(false);
    const downloadLink = brochure.downloadUrl || brochure.sharedUrl || brochure.previewUrl;

    return (
        <>
            <Button variant="success" style={{ marginRight: '15px' }} onClick={() => setShowBrochure(true)}>
                <Trans i18nKey="Preview" />
            </Button>
            <Button as="a" href={downloadLink} target="_blank" rel="noopener noreferrer" variant="outline-success">
                <Trans i18nKey="Download" />
            </Button>
            <NewsLetterModal
                pdfUrl={brochure.previewUrl}
                name={brochure.title}
                showBrochure={showBrochure}
                setShowBrochure={setShowBrochure}
            />
        </>
    );
}

export default NewsLetterButton;